<template>
  <div>
    <v-snackbar
    v-model="exibe_alerta"
    timeout="2000"
    :color="alerta_color"
    >
    {{ alerta }}
    </v-snackbar> 

    <v-container fluid >
      <v-row >
        <v-col >
          <!-- Esse card é a imagem de fundo -->
          <v-card
            class="rounded-0"
            flat
          >
            <v-img
              src="img/saco_dinheiro.png"
            >
              
              <v-toolbar flat dense tile >
                <v-app-bar-nav-icon class="d-lg-none ml-n6" @click.stop="$store.commit('switchSidebar');"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-h5 ml-n5"  >{{titulo}}</v-toolbar-title>
              </v-toolbar>


              <v-card-text style="height:95%">
              <v-row v-if="loading" class="mt-5">
                <v-col>
                  <div class="text-center" >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-col>
              </v-row>  
              <v-row v-if="loading" >
                <v-col>
                  <div class="text-center" >Carregando</div>
                </v-col>
              </v-row> 
            
              <v-form 
                ref="form"
                lazy-validation
              >
                <v-row v-if="!loading && !exibeDocumento && !naoEncontrado && this.planos_contracheque.length > 1">
                  <v-col cols="12" md="4" >
                    
                    <v-select
                      v-model="plano"
                      outlined
                      dense
                      :items="planos_contracheque"
                      :rules="Rules.Required"
                      placeholder="Plano"
                      item-text="sigla_plano"
                      item-value="item"
                      return-object
                      @change="meses"
                    >
                    </v-select>
                    
                  </v-col>
                </v-row> 


                <v-row v-if="!loading && !exibeDocumento && !naoEncontrado">
                  <v-col cols="12" md="4" >
                    
                    <v-select
                      v-model="folha"
                      outlined
                      dense
                      :items="folhas"
                      :rules="Rules.Required"
                      placeholder="Mês/Ano"
                      return-object
                      no-data-text="Carregando..."
                    >
                      <template slot="selection" slot-scope="data">
                        {{ data.item.nr_mes_ref.padStart(2,'0') }}/{{ data.item.nr_ano_ref }} - {{ data.item.nm_tipo_folha }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.nr_mes_ref.padStart(2,'0') }}/{{ data.item.nr_ano_ref }} - {{ data.item.nm_tipo_folha }}
                      </template>
                    </v-select>
                    
                  </v-col>
                </v-row>    
              </v-form>

                
              </v-form>


              <v-row v-if="!loading && !exibeDocumento && !naoEncontrado">
                <v-col cols="12"  >
                  
                    <v-btn v-if="!isMobile()" color="primary" rounded dark @click="executar" >Visualizar</v-btn>
                    <v-btn v-if="isMobile()" color="primary" rounded dark @click="baixar" >Baixar PDF</v-btn>
                </v-col>
              </v-row>  


              <v-row v-if="!loading && naoEncontrado">
                <v-col cols="12" >
                  
                    <v-alert class="text-h5" text type="info" color="blue darken-4" >{{mensagem}}</v-alert>
                  
                </v-col>
              </v-row> 


              <v-row v-if="!loading && exibeDocumento">
                <v-col cols="12" md="12" class="text-right">

                  
                    <v-btn color="primary" rounded dark @click="exibeDocumento=false;fileURL=null;" >Voltar</v-btn>
                
                  
                </v-col>
              </v-row> 


              <v-row v-if="!loading && exibeDocumento" class="fill-height mt-n5" >
                <v-col cols="12" md="12" >
                    <v-card-text style="height:98%">     
                      <iframe :src="'data:Application/pdf;base64,'+ fileURL" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>
                    </v-card-text>
                </v-col>
                
              </v-row> 
              

              <v-overlay
                absolute
                :value="dialog"
              >
              </v-overlay>

              <v-snackbar
                v-model="dialog"
                multi-line
                centered
                :color="cor_dialogo"
                timeout="-1"
                max-width="400"
                min-height="140"
                vertical
              >
                {{ mensagem }}

                <template v-slot:action="{ attrs }">
                  <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="BtnOk(titulo)"
                    v-if="!sim_nao"
                  >
                    Ok
                  </v-btn>
                  <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="BtnSim(titulo)"
                    v-if="sim_nao"
                  >
                    Sim
                  </v-btn>
                          <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="BtnNao(titulo)"
                    v-if="sim_nao"
                  >
                    Não
                  </v-btn>
                </template>
              </v-snackbar> 
              </v-card-text>
            </v-img>
          </v-card>
        </v-col>
      </v-row>      
    </v-container>
  </div>
</template>

<script>
   export default {
      data: function(){
         return {
            Rules:{
              Required: [v => !!v || 'Obrigatório',]
            },
            titulo: "Contracheque",
            form_valido: true,
            loading: true,
            mensagem: '',
            dialog: false,
            cor_dialogo: '#B00020',
            exibe_alerta: false,
            alerta: '',
            alerta_color: "green",
            sim_nao: false,
            fileURL: null,
            exibeDocumento: false,
            naoEncontrado: false,
            plano: null,
            planos_contracheque: [],
            folhas: [],
            folha: null,
         }
      },

      created: function() {

        let params = {
            api: this.$API,
            descricao: this.titulo
        }

        this.$store.dispatch('logatendimento', params); 

        var texto = '';
        this.$store.dispatch('exibeajuda',texto);

        if(this.$store.state.alerta != ''){
           this.alerta = this.$store.state.alerta;
           this.$store.commit('setalerta','');
           this.exibe_alerta = true;
        }

        

        this.inicia();

        
      },
            
 
      methods: {



        //#####################
        //click dos botões da tela
        //####################
        
        BtnOk(){

          this.dialog = false;
          this.titulo = '';
          this.mensagem = '';
             
          this.sair();
           
        }, 

        BtnSim(){

          this.dialog = false;
          this.titulo = '';
          this.mensagem = '';
             
          this.sair();
           
        }, 


        BtnNao(){

          this.dialog = false;
          this.titulo = '';
          this.mensagem = '';
             
          
        }, 


        sair(){

          this.$router.push('/');        

        },  

        

        //######################################
        //# Busca os contratos do participante
        //###################################### 

        inicia(){

          this.loading = true;
          
          this.planos_contracheque = [];
          let ja_existe;
          for(let i=0, x=this.$store.state.planos_usuario.length; i<x; i++){
            for(let j=0, z=this.$store.state.planos_contracheque.length; j<z; j++){
              if(this.$store.state.planos_usuario[i].id_plano == this.$store.state.planos_contracheque[j]){
                ja_existe = this.planos_contracheque.some(id_plano => id_plano === this.$store.state.planos_usuario[i].id_plano);
                if(!ja_existe){
                  this.planos_contracheque.push(this.$store.state.planos_usuario[i]);
                }
              }
            }  
          }

          if(this.planos_contracheque.length == 1){
             this.plano = this.planos_contracheque[0];
             this.meses();
          }else{
            if(this.planos_contracheque.length == 0){
                this.naoEncontrado = true;
                this.mensagem = 'Nenhum contracheque encontrado.'
            }
          }


          this.loading = false; 
          

        },

        
        meses(){

          this.folhas = [];

          var params = {
            id_pessoa: this.plano.id_pessoa,
            id_plano: this.plano.id_plano,
          }

          
          this.$API.post( '/api/contracheque/inicia', params)
          .then(response => {

      

            this.folhas = response.data;
            
            this.naoEncontrado = false;
            this.loading = false;             

          })
          .catch(error => {
              this.loading = false;
          });  

        },
        
        
        
        executar(){

          if( this.$refs.form.validate() ){

            this.loading = true;


            var params = {
                plano: this.plano.id_plano,
                cpf: this.$store.state.pessoa_fisica.cpf,
                folha: this.folha.id_tipo_folha,
                mes: this.folha.nr_mes_ref,
                ano:this.folha.nr_ano_ref,
                id_pessoa: this.plano.id_pessoa
            }

            

            this.$API.post( '/api/contracheque/pdf', params)
            .then(response => {

              if(response.data.codigo =='ok'){
                
                this.fileURL = response.data.arquivo;
                this.exibeDocumento = true;

              }else{
                this.mensagem = response.data.mensagem;
                this.naoEncontrado = true;
              }
              
              this.loading = false;             

            })
            .catch(error => {
                this.loading = false;
            });

          }

          
          

        },



        baixar(){

          if( this.$refs.form.validate() ){

            this.loading = true;


            var params = {
                plano: this.plano.id_plano,
                cpf: this.$store.state.pessoa_fisica.cpf,
                folha: this.folha.id_tipo_folha,
                mes: this.folha.nr_mes_ref,
                ano:this.folha.nr_ano_ref,
                id_pessoa: this.plano.id_pessoa
            }

            

            this.$API.post( '/api/contracheque/pdf', params)
            .then(response => {

              if(response.data.codigo =='ok'){
                
                //window.open('data:Application/pdf;base64,'+ response.data.arquivo);
                const linkSource = `data:application/pdf;base64,${response.data.arquivo}`;
                const downloadLink = document.createElement("a");
                const fileName = "contracheque_"+this.folha.nr_ano_ref+"_"+this.folha.nr_mes_ref+".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();

              }else{
                this.mensagem = response.data.mensagem;
                this.naoEncontrado = true;
              }
              
              this.loading = false;             

            })
            .catch(error => {
                this.loading = false;
            });

          }

          
          

        },

        isMobile: function() {
    	    var check = false;
          (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
           return check;
        },



        TrataErros(error){

          console.log(error.response);

          this.cor_dialogo = '#B00020';
          this.loading = false;
          this.sim_nao = false;
          this.titulo = 'Alerta';
          this.mensagem = 'Ocorreu um problema, o sistema será finalizado.';
          

          var token_expirado = false;
          if('data' in error.response){
            if('mensagem' in error.response.data){
              if( error.response.data.mensagem == 'Token expirado'){
                token_expirado = true;
              }  
            }

            if(token_expirado){
              this.mensagem = 'Sua sessão expirou. Faça um novo login.';
            } 
          }

          this.dialog = true;

          var usuario = {
              logado: false,
              nome: '',
              id: '',
              email: '',
              matricula: '',
              id_setor: ''
            };

            this.$store.commit('setusuariologado', usuario);
        } 

      },
   }
</script>